// Branding fetched from /api/config/branding (app name, tagline, start text,
// privacy link). Null until loaded; consumers must handle both states.
let branding = null;

export function setBranding(value) {
  branding = value;
}

export function getBranding() {
  return branding;
}
